import { Col, Row } from 'antd';
import React from 'react';
import styled from '@emotion/styled';
import { omit } from 'lodash';

import WithDataSource from './with-data-source';
import { InstructiveLabel } from './element-list';

import { Tooltip } from '../..';
import { FormComponentType } from '../../../types/form';
import FormItem from '../form-item';
import { formatUniversityFederalCode, FINANCIAL_PORTAL_FEDERAL_CODE } from '../../../utils/form-builder';

const LabelContainer = styled.div`
  margin-bottom: 24px; /* match with form-item */
`;

export function fieldComponentRenderer(
  type: FormComponentType,
  attributes: any,
  error: any,
  Comp: React.ComponentType<any>
) {
  const { label, instructiveLabel: origInstructiveLabel, dataSource, ...rest } = omit(attributes, 'itemIndex');
  const instructiveLabel = origInstructiveLabel && (
    <InstructiveLabel isLabel={type === FormComponentType.Label}>{origInstructiveLabel}</InstructiveLabel>
  );

  // transformTitle is removed from the schema due to being cloned
  if (!dataSource?.transformTitle && rest?.name === FINANCIAL_PORTAL_FEDERAL_CODE) {
    dataSource.transformTitle = formatUniversityFederalCode;
  }

  let result = (
    <FormItem
      label={label}
      instructiveLabel={instructiveLabel}
      htmlFor={attributes.name}
      error={error}
      componentType={type}
    >
      {dataSource ? (
        <WithDataSource type={type} dataSource={dataSource} {...rest}>
          <Comp />
        </WithDataSource>
      ) : (
        <Comp {...rest} />
      )}
    </FormItem>
  );
  switch (type) {
    case FormComponentType.Label:
      result = (
        <LabelContainer>
          <Comp {...rest} />
          {instructiveLabel}
        </LabelContainer>
      );
      break;
    case FormComponentType.DocumentTypeMetadataTitle:
    case FormComponentType.LinkToPage:
      result = (
        <FormItem>
          {label ? (
            <Tooltip title={label}>
              <Comp {...rest} />
            </Tooltip>
          ) : (
            <Comp {...rest} />
          )}
          {instructiveLabel}
        </FormItem>
      );
      break;
    case FormComponentType.RichTextEditor:
      if (attributes.name === 'mentorship_reason' || attributes.name === 'career_coach_reason') {
        result = (
          <FormItem label={label} instructiveLabel={instructiveLabel} htmlFor={attributes.name} error={error}>
            <Comp {...rest} limit={250} />
          </FormItem>
        );
      }
  }
  return (
    <Col xs={24} md={24}>
      {result}
    </Col>
  );
}

export default function defaultFieldRenderer(
  type: FormComponentType,
  attributes: any,
  error: any,
  Comp: React.ComponentType<any>
) {
  return <Row gutter={[16, 0]}>{fieldComponentRenderer(type, attributes, error, Comp)}</Row>;
}
